export default __webpack_public_path__ + "static/media/map-pin.a4632516.svg";